/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./EditVideoSlide.module.css";
import { FormControlLabel, Switch, withStyles } from "@material-ui/core";
import { AppState } from "../../root/RootReducer";
import PuiMessage from "../widgets/PuiMessage";
import PuiButton from "../elements/PuiButton";
import PuiTypography from "../elements/PuiTypography";
import ShowFileIcon from "../../pages/vod/Common/ShowFileIcon";
import { Video, VideoSlide } from "../../common/video/models/Video";
import AddTimeStampSlideGroup from "../widgets/AddTimeStampSlideGroup";
import {
  GetVideoSlide,
  EditVideoSlide,
  UploadVideoSlide,
  DeleteVideoSlide,
} from "../../common/video/VideoActions";
import { useNavigate } from "react-router-dom";
interface EditVideoSlideProps {
  videoId: number;
  video: Video;
  // モーダルを閉じる
  CloseEditVideoTab: () => void;
  isSaved: boolean;
  setIsSaved: (isSaved: boolean) => void;
  ForceCloseEditVideoModal: () => void;
}

function EditVideoSlideModal({
  videoId,
  video,
  CloseEditVideoTab,
  isSaved,
  setIsSaved,
  ForceCloseEditVideoModal,
}: EditVideoSlideProps) {
  const RedSwitch = withStyles({
    switchBase: {
      color: "var(--red)",
      "&$checked": {
        color: "var(--red)",
      },
      "&$checked + $track": {
        backgroundColor: "var(--red)",
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const dispatch = useDispatch();
  const history = useNavigate();

  const { videos, videoPdf } = useSelector((state: AppState) => ({
    videos: state.video.videos,
    videoPdf: state.video.videoPdf,
  }));

  // アップロード画面にするか、スライド編集画面にするかのフラグ
  const [isStartUploadSlide, ChangeStartUploadedSlideFlag] = useState(true);

  useEffect(() => {
    if (video.videoSlides.length > 0) {
      dispatch(GetVideoSlide(String(videoId), "1"));
    } else {
      ChangeStartUploadedSlideFlag(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ビデオURL
  const sourceUrl = video.sourceUrl;
  const videoRef = useRef<HTMLVideoElement>(null);

  // アップロード画面でスライドが既にある場合、削除できるかを判断する
  const [isReadyToDeleteSlide, ChangeReadyToDeleteSlideFlag] = useState(false);
  useEffect(() => {
    if (isStartUploadSlide) {
      if (videoPdf) {
        ChangeReadyToDeleteSlideFlag(true);
      } else {
        ChangeReadyToDeleteSlideFlag(false);
      }
    } else {
      ChangeReadyToDeleteSlideFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStartUploadSlide]);

  // スライドファイルをローカルからアップロード
  const inputSlideRef = useRef<HTMLInputElement>(null);
  const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
  const CloseErrorInputBar = () => {
    ChangeErrorInputSize(false);
  };
  const [slideName, InputSlideName] = useState("");
  const [slideFileType, InputSlideFileType] = useState("");

  const UserUploadSlide = (event: any) => {
    console.log("UserUploadSlideStart");
    if (event.target.files.length === 1) {
      if (event.target.files[0].size > 0) {
        if (event.target.files[0].size >= 104857600) {
          ChangeErrorInputSize(true);
          if (inputSlideRef.current) {
            inputSlideRef.current.value = "";
          }
        } else {
          InputSlideName(event.target.files[0].name);
          InputSlideFileType(event.target.files[0].type);
          dispatch(
            UploadVideoSlide({
              videoId: video.id,
              file: event.target.files[0],
              slideName: "",
              isPublic: isPublic,
              videoSlides: [{ slideId: 1, startMillis: -1, videoId: videoId }],
            })
          );
          setIsSaved(false);
        }
      } else {
        ChangeErrorInputSize(true);
        if (inputSlideRef.current) {
          inputSlideRef.current.value = "";
        }
      }
    }
  };

  // スライドの公開非公開の設定
  const [isPublic, ChangeSlidePublic] = useState(false);

  const SwitchPublicState = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    console.log("SwitchPublicState start");
    setIsSaved(false);
    ChangeSlidePublic(checked);
  };

  // スライド編集画面でスライドの時間割り当て
  const [slideList, SetSlideList] = useState<VideoSlide[]>([]);

  useEffect(() => {
    if (videoPdf && videoPdf.videoSlides) {
      if (Number(videoPdf.videoSlides[0].videoId) === Number(videoId)) {
        SetSlideList(videoPdf.videoSlides);
        InputSlideFileType(videoPdf.slideUrl);
        InputSlideName(videoPdf.slideName);
        ChangeSlidePublic(videoPdf.isPublic);
        ChangeStartUploadedSlideFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoPdf]);

  // アップロード済みのスライドの削除
  const DeleteSlide = (documentIndex: number) => {
    console.log("DeleteSlide start");
    InputSlideName("");
    InputSlideFileType("");
    if (inputSlideRef.current) {
      inputSlideRef.current.value = "";
    }
    ChangeStartUploadedSlideFlag(true);
    setIsSaved(false);
  };

  const ClickCancelButton = () => {
    console.log("ClickCancelButton start");
    CloseEditVideoTab();
  };

  const ClickDoneButton = () => {
    console.log("ClickDoneButton start");
    if (isReadyToDeleteSlide) {
      setIsSaved(true);
      ForceCloseEditVideoModal();
      dispatch(DeleteVideoSlide(videoId));
      history("/videos");
    } else {
      setIsSaved(true);
      ForceCloseEditVideoModal();
      if (videoPdf) {
        dispatch(
          EditVideoSlide({
            videoId: video.id,
            file: null,
            slideName: videoPdf.slideName,
            isPublic: isPublic,
            videoSlides: slideList,
          })
        );
      }
      history("/videos");
    }
  };

  return (
    <>
      {isStartUploadSlide ? (
        <div className={styles.root}>
          <div className={styles.title}>
            <PuiTypography size={20} bold>
              {videos[videoId].title}
            </PuiTypography>
          </div>
          <div className={styles.slideDetailLong}>
            <div className={styles.slideTypeText}>Slide資料</div>
            <div className={styles.form}>
              <label className={styles.uploadButton}>
                <input
                  ref={inputSlideRef}
                  id="inputSlideUploader"
                  accept="application/pdf"
                  multiple
                  type="file"
                  onChange={UserUploadSlide}
                  className={styles.fileDisplay}
                />
                アップロードするファイルを選択(100MBまで)
              </label>
            </div>
          </div>
          <div className={styles.bottomButtonAbsolute}>
            <div className={styles.cancelButton}>
              <PuiButton onClick={ClickCancelButton}>キャンセル</PuiButton>
            </div>
            <div className={styles.doneButton}>
              <PuiButton
                onClick={ClickDoneButton}
                isActive={isReadyToDeleteSlide}
              >
                編集完了
              </PuiButton>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.root}>
          <div className={styles.title} style={{ display: "flex" }}>
            <PuiTypography size={20} bold>
              {videos[videoId].title}
            </PuiTypography>
            <FormControlLabel
              label={isPublic ? "公開" : "非公開"}
              style={{ marginTop: "-15px" }}
              control={
                <RedSwitch
                  checked={isPublic}
                  className={styles.switch}
                  onChange={SwitchPublicState}
                  name="isPublic"
                />
              }
            />
          </div>
          <div className={styles.slideDetail}>
            <div className={styles.slideTypeText}>Slide資料</div>
            <div className={styles.slideTypeIcon}>
              <ShowFileIcon
                isVisibleFileName
                fileName={slideName}
                fileType={slideFileType}
                isVisibleDeleteIcon
                DeleteFile={DeleteSlide}
              />
            </div>
          </div>

          <div className={styles.video}>
            <video
              id="videoPlayer"
              className={
                videoRef.current &&
                videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                  ? styles.LandscapeVideo
                  : styles.PortraitVideo
              }
              controls
              width="100%"
              ref={videoRef}
              key={sourceUrl}
              controlsList="nodownload"
              disablePictureInPicture
              style={{ display: "block", float: "right" }}
            >
              <source src={sourceUrl} type="video/mp4" />
            </video>
          </div>

          <div className={styles.slideList}>
            <PuiTypography>Slideの開始時刻を設定</PuiTypography>
            <div className={styles.slideArea}>
              <AddTimeStampSlideGroup
                slideList={slideList}
                SetSlideList={SetSlideList}
                videoRef={videoRef}
                setIsSaved={setIsSaved}
                videoId={videoId}
              />
            </div>
          </div>
          <div className={styles.bottomButton}>
            <div className={styles.cancelButton}>
              <PuiButton onClick={ClickCancelButton}>キャンセル</PuiButton>
            </div>
            <div className={styles.doneButton}>
              <PuiButton isActive={!isSaved} onClick={ClickDoneButton}>
                編集完了
              </PuiButton>
            </div>
          </div>
        </div>
      )}
      <PuiMessage
        open={isErrorInputSize}
        type="error"
        title="正しいファイルを選択してください(1~100MB)"
        duration={5000}
        onClose={CloseErrorInputBar}
      />
    </>
  );
}

export default EditVideoSlideModal;
